<template>
    <div class="college-box">
        <div class="college">
            <div class="topHeader">
                <h5 class="college-caption">college</h5>
                <ul class="navul">
                    <li class="nav-item-li" v-for='(item,index) in childNav' :key='index' @click='changeId(index+1)'>
                        {{item.name}}</li>
                </ul>
            </div>
            <ul class="item-blog-ul">
                <li class="item-blog-li" v-for='(item,index) in blogData' :key='index' v-loading='loading' @click='toPath(item)'>
                    <div class="item-img" :style='{backgroundImage:"url("+item.main_img_url+")"}'></div>
                    <div class="item-center-box">
                        <span class="time">{{item.created_at}}</span>
                        <h5 class="item-caption">{{item.title}}</h5>
                        <p class="item-center" v-html='item.content'></p>
                        <span class="item-button">Read the articale</span>
                    </div>
                </li>
            </ul>
            <el-pagination layout="prev, pager, next" :pager-count="5" :total="total_pages*10"
                @current-change='changecurrent' class="pages">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'College',
        data() {
            return {
                loading: true,//加载页面
                numbers: {//页面码数
                    id: 1,
                    page: 1,
                    meta: {}

                },
                total_pages:undefined,
                childNav: [
                    {
                        name: '线上活动'
                    },
                    {
                        name: '线下活动'
                    },
                    {
                        name: '营销工具'
                    }
                ],
                blogData: [
                    {
                        main_img_url: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/home/banner1.jpg',
                        created_at: '2020-06-22',
                        title: '品牌策划的规律，这些您掌握了吗？',
                        content: '在如今品牌是竞争关键的核心时代，每一个企业都在进行品牌策划，但是巴顿品牌策划的规律你掌握了吗？每一个企业都在进行品牌策划'
                    },
                    {
                        main_img_url: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/home/banner1.jpg',
                        created_at: '2020-06-22',
                        title: '品牌策划的规律，这些您掌握了吗？',
                        content: '在如今品牌是竞争关键的核心时代，每一个企业都在进行品牌策划，但是巴顿品牌策划的规律你掌握了吗？每一个企业都在进行品牌策划'
                    },
                    {
                        main_img_url: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/home/banner1.jpg',
                        created_at: '2020-06-22',
                        title: '品牌策划的规律，这些您掌握了吗？',
                        content: '在如今品牌是竞争关键的核心时代，每一个企业都在进行品牌策划，但是巴顿品牌策划的规律你掌握了吗？每一个企业都在进行品牌策划'
                    },
                    {
                        main_img_url: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/home/banner1.jpg',
                        created_at: '2020-06-22',
                        title: '品牌策划的规律，这些您掌握了吗？',
                        content: '在如今品牌是竞争关键的核心时代，每一个企业都在进行品牌策划，但是巴顿品牌策划的规律你掌握了吗？每一个企业都在进行品牌策划'
                    },
                    {
                        main_img_url: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/home/banner1.jpg',
                        created_at: '2020-06-22',
                        title: '品牌策划的规律，这些您掌握了吗？',
                        content: '在如今品牌是竞争关键的核心时代，每一个企业都在进行品牌策划，但是巴顿品牌策划的规律你掌握了吗？每一个企业都在进行品牌策划'
                    }
                ]
            }
        },
        mounted() {
            this.getList(this.numbers.id, this.numbers.page)
        },
        methods: {
            getList(id, page) {//获取文章列表
                this.$axios.get(this.$API.lookArticl, {
                    params: {
                        'article_type_id': id,
                        'per_page': 5,
                        'page': page
                    }
                }
                )
                    .then(res => {
                        this.blogData = res.data.data
                        this.numbers.meta = res.data.meta
                        this.total_pages=res.data.meta.pagination.total_pages
                        // console.log(this.numbers.meta)
                        this.changeContent()
                    })
                    .catch(err => {
                        this.$message.error('文章列表获取失败，刷新页面重试')
                    })
            },
            // 过滤获取的富文本标签
            changeContent() {
                let _this = this;
                for (let i in this.blogData) {
                    let str = this.blogData[i].content;
                    str = str.replace(/(\n)/g, "");
                    str = str.replace(/(\t)/g, "");
                    str = str.replace(/(\r)/g, "");
                    str = str.replace(/<\/?[^>]*>/g, "");
                    // str = str.replace(/\s+/g,"");//去除空格
                    this.blogData[i].content = str;
                }
                setTimeout(() => {
                    _this.loading = false
                }, 1000)
            },
            changeId(id) {//改变获取的文章系列id
                this.numbers.id = id
                this.numbers.page = 1
                // console.log(id)
                this.loading = true
                this.getList(this.numbers.id, this.numbers.page)
            },
            changecurrent(val) {//改变页码
                this.loading = true
                this.numbers.page = val
                this.getList(this.numbers.id, this.numbers.page)
            },
            toPath(item){
                window.sessionStorage.setItem('articalid',item.id)
                window.location.href=`/artical/${item.title}?id=${item.id}`
            }
        }
    }
</script>
<style scoped>
    .college-box {
        padding-bottom: 115px;
    }

    .college {
        max-width: 85.4%;
        margin: 0 auto;
    }

    .topHeader {
        display: flex;
        align-items: flex-end;
    }

    .college-caption {
        text-transform: uppercase;
        font-size: 80px;
        font-family: gilroybold4;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
    }

    .navul {
        display: flex;
        justify-content: center;
        margin-left: 36px;

    }

    .nav-item-li {
        padding: 0 52px;
        font-size: 24px;
        font-weight: 400;
        line-height: 52px;
        color: rgba(153, 153, 153, 1);
        cursor: pointer;
    }

    .nav-item-li:not(:last-child) {
        border-right: 1px solid #CCCCCC;
    }

    .item-blog-ul {
        margin-top: 54px;
    }

    .item-blog-li {
        padding: 28px;
        background-color: #ffff;
        display: grid;
        grid-template-columns: 30% 60%;
        grid-column-gap:10%;
    }

    .item-blog-li:not(:first-child) {
        margin-top: 40px;
    }

    .item-img {
        height: 24.78vw;
        background: #666666 no-repeat center center;
        background-size: cover;
    }

    .item-center-box {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
    }

    .time {
        font-size: 16px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        /* margin-bottom: 40px; */
    }

    .item-caption {
        font-size: 24px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        /* margin-bottom: 40px; */
    }

    .item-center {
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        color: rgba(153, 153, 153, 1);
        max-width: 752px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        /* margin-bottom: 121px; */
    }

    .item-button {
        font-size: 24px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        text-decoration: underline;
        cursor: pointer;
    }

    .pages {
        display: flex;
        justify-content: center;
        margin-top: 116px;
    }

    .pages>>>button,
    .pages>>>ul,
    .pages>>>li {
        background-color: #F0F0F0;
    }

    .pages>>>.number {
        font-size: 24px;
        padding: 0 30px;

    }
    @media(max-width: 1168px){
        .college-caption {
        font-size: 40px;
    }
    }
    @media(max-width:995px){
        .college {
        max-width: 100%;
        margin: 5% auto;
    }
    
    .college-caption {
        font-size: 24px;
    }
    
    .navul {
        margin-left: 5%;
        width: 100%;

    }
    .nav-item-li {
        padding: 0 2%;
        font-size: 16px;
        line-height: 100%;
    }
    .item-blog-ul {
        margin-top:5%;
    }
    .item-blog-li:not(:first-child) {
        margin-top: 0px;
    }
    .item-blog-li {
        padding:5%;
        background-color: #ffff;
        display: grid;
        grid-template-columns:1fr;
    }
    .item-img {
        height:90vw;
    }
    .item-center-box {
        padding:5% 0;
        min-height: 200px;
    }
    .pages {
        margin-top:5%;
    }
    .college-box {
        padding-bottom: 0px;
    }
    .item-caption {
        white-space: normal;
        /* margin-bottom: 40px; */
    }
    }

    /* @media(max-width: 1023px) {
        .nav-item-li {
            padding: 0 52px;
            font-size: 50px;
            font-weight: 400;
            line-height: 216%;
        }

        .item-blog-li {
            padding: 5%;
            background-color: #ffff;
            display: grid;
            grid-template-columns: 1fr;
            grid-column-gap: 92px;
        }

        .college-caption {
            font-size: 130px;
        }

        .item-img {
            height: 1500px;
        }

        .time {
            font-size: 50px;
            margin-top: 5%;
        }

        .item-caption {
            font-size: 75px;
        }

        .item-center {
            font-size: 50px;
            line-height: 150%;
            color: rgba(153, 153, 153, 1);
            max-width: 100%;
        }

        .item-button {
            font-size: 50px;
            font-weight: 400;
        }
    }

    @media(max-width: 375px) {
        .college-caption {
            font-size: 120px;
        }
    }

    @media(max-width: 320px) {
        .college-caption {
            font-size: 92px;
        }
    } */
</style>


// WEBPACK FOOTER //
// src/components/main/school/college.vue